import React from "react";
import PropTypes from 'prop-types';
import moment from "moment";
import queryString from "query-string";

import DateTimePicker from "@components/common/date_time_picker/main";
import Checkbox from "@components/common/checkbox/main";
import ClipboardCopy from "@components/common/clipboard_copy/main";
import { pluralizeObject, Resource } from "@helpers/show_page_helpers";
import renderModal from "@components/show_page/modals/renderModal";


class BulkShareModal extends React.Component {
  state = {
    availability_end_date: moment().add(7, 'days').format("MM/DD/YYYY"),
    availability_end_time: "11:59 pm",
    availability_end_zone: moment.tz.guess(),
    expires: false,
    internal: false, // user can update in bulk share modal
    link: null,
    manifestKey: null,
    name: this.defaultName,
    require_identification: false,
    restrict_shares_setting: false, // BF setting, enforced before_save
    require_share_identification_setting: false, // BF setting, enforced before_save
    newShareLink: false,
    showFeedback: false
  };

  componentDidMount() {
    if (this.props.digest) {
      this.getShareLink();
    } else {
      this.createShareLink();
    }
  }

  componentWillUnmount() {
    this.props.closeModal();
  }

  get defaultName() {
    return `${BF.fx.should_pluralize(
      this.props.selectedAssetKeys.size,
      "Asset"
    )} from ${Resource.name}`;
  }

  handleChange = (event) => {
    this.setState({ [event.target.name]: event.target.value });
  };

  updateDateTimeEnd = (availability_end_date, availability_end_time, availability_end_zone) => {
    this.setState({
      availability_end_date,
      availability_end_time,
      availability_end_zone
    });
  };

  availability_end = () => {
    const { availability_end_time, availability_end_date } = this.state;
    let { availability_end_zone } = this.state;

    availability_end_zone = availability_end_zone || moment.tz.guess();

    return moment.tz(
      `${availability_end_date} ${availability_end_time}`,
      "MM/DD/YYYY hh:mm a",
      availability_end_zone
    );
  }

  buildDataBody = () => {
    const { name, internal, require_identification, expires } = this.state;
    return {
      data: {
        attributes: {
          asset_keys: Array.from(this.props.selectedAssetKeys),
          name,
          internal,
          require_identification,
          expires,
          availability_end: expires ? this.availability_end().format() : null
        }
      }
    };
  }

  updateStateWith = (serializedResponse, newShareLink) => {
    const {
      link,
      internal,
      require_identification,
      expires,
      availability_end,
      restrict_shares_setting,
      require_share_identification_setting,
      name
    } = serializedResponse.data.attributes;
    const availability_end_moment = moment(availability_end).isValid()
      ? moment(availability_end)
      : this.availability_end();
    this.setState({
      link,
      internal,
      require_identification,
      expires,
      availability_end_date: availability_end_moment.format("MM/DD/YYYY"),
      availability_end_time: availability_end_moment.format('hh:mm a'),
      restrict_shares_setting,
      require_share_identification_setting,
      manifestKey: serializedResponse.data.id,
      name,
      newShareLink
    });
  }

  createShareLink = () => {
    const { type, key } = Resource;
    const url = `/api/v4/${BF.fx.pluralize(type)}/${key}/share_manifests`;

    $.ajax({
      type: "POST",
      url,
      contentType: "application/json",
      data: JSON.stringify(this.buildDataBody()),
      context: this,
      headers: { Authorization: `Bearer ${BF_Token}` },
      success: (response) => {
        this.updateStateWith(response, true);
        this.props.selectedAssetKeys.forEach((assetKey) => {
          Insight.createEvent('shared', assetKey, 'asset');
        });
      },
      error: () => this.props.closeModal()
    });
  }

  getShareLink = () => {
    const url = `/api/v4/share_manifests/${this.props.digest}`;
    $.ajax({
      type: "GET",
      url,
      contentType: "application/json",
      context: this,
      headers: { Authorization: `Bearer ${BF_Token}` },
      success: (response) => this.updateStateWith(response, false),
      error: () => this.props.closeModal()
    });
  }

  updateShareLink = () => {
    const { manifestKey } = this.state;
    const url = `/api/v4/share_manifests/${manifestKey}`;

    $.ajax({
      type: "PUT",
      url,
      contentType: "application/json",
      data: JSON.stringify(this.buildDataBody()),
      context: this,
      headers: { Authorization: `Bearer ${BF_Token}` },
      success: () => {
        this.setState({ showFeedback: true },
          () => setTimeout(() => this.setState({ showFeedback: false }), 2000));
      },
      error: () => {}
    });
  }

  redirectToContextable = () => {
    if (BF.fx.collection().slug && BF.fx.brandfolder().slug) {
      window.location.href = `/${BF.fx.brandfolder().slug}/${BF.fx.collection().slug}`;
    } else if (BF.fx.brandfolder().slug) {
      window.location.href = `/${BF.fx.brandfolder().slug}`;
    } else {
      window.location.href = "/";
    }
  }

  deleteShareLink = () => {
    const sweetAlertOptions = {
      title: "Delete share link",
      text: "Are you sure you want to delete?",
      type: "warning",
      showCancelButton: true,
      cancelButtonText: "No",
      confirmButtonText: "Delete",
      closeOnConfirm: true,
      customClass: "deleting"
    };

    window.swal(sweetAlertOptions, (confirm) => {
      if (confirm) {
        $.ajax({
          type: "DELETE",
          url: `/api/v4/share_manifests/${this.state.manifestKey}`,
          contentType: "application/json",
          context: this,
          headers: { Authorization: `Bearer ${BF_Token}` },
          success: () => {
            this.props.closeModal();
            Notify.create({ title: "Share link deleted", type: "success" });
            if (!this.state.newShareLink) {
              this.redirectToContextable();
            }
          },
          error: () => {}
        });
      }
    });
  }

  renderRestrictedContent = (indicator) => {
    const { restrict_shares_setting, internal, require_share_identification_setting } = this.state;
    const labelCopy = <h5>{t('Require Identification')}</h5>;

    if (indicator === "link_access_options" && !restrict_shares_setting) {
      return (
        <div className="modal-row">
          <div className="radio-button-container">
            <label className="radio-row private">
              <h4> {t('Public')} </h4>
              <input
                className="radio-input"
                type="radio"
                value="option1"
                checked={!this.state.internal}
                onChange={() => this.toggleRestrictSharing()}
              />
              <span className="radio-dot" />
            </label>

            <label className="radio-row public">
              <h4> {t('Private')} </h4>
              <input
                className="radio-input"
                type="radio"
                value="option1"
                checked={this.state.internal}
                onChange={() => this.toggleRestrictSharing()}
              />
              <span className="radio-dot" />
            </label>
          </div>
        </div>
      );
    }

    if (indicator === "require_identification_checkbox" && !restrict_shares_setting && !require_share_identification_setting && !internal) {
      const { require_identification } = this.state;
      return (
        <Checkbox
          size="sm"
          checked={this.state.require_identification}
          toggle={() => this.setState({ require_identification: !require_identification })}
          labelHtml={labelCopy}
          tooltipCopy={t("When enabled, visitors will be asked to provide their email address before viewing assets. This helps identify who has opened this link.")}
        />
      );
    }

    return null;
  }

  toggleLinkExpiration() {
    if (this.state.expires) {
      this.setState({ expires: false });
    } else {
      this.setState({ expires: true });
    }
  }

  toggleRestrictSharing() {
    if (this.state.internal) {
      this.setState({
        internal: false
      });
    } else {
      this.setState({
        internal: true,
        require_identification: false
      });
    }
  }

  render() {
    const {
      link,
      name,
      internal,
      expires,
      availability_end_date,
      availability_end_time,
      availability_end_zone,
      restrict_shares_setting,
      newShareLink,
      showFeedback
    } = this.state;

    const assetQtyObject = pluralizeObject(Array.from(this.props.selectedAssetKeys));
    const assetCopy = assetQtyObject.plural ? t('assets') : t('asset');
    const restrictedCopy = restrict_shares_setting ? t(" For Users of This Brandfolder") : "";
    const shareCopy = internal ? t('Private Share Link') : t('Public Share Link');
    const labelCopy = <h5> {t('Expire Link')} </h5>;

    return (
      <div className="modal-content-wrapper bulk-share-modal">
        <div className="modal-content-wrapper__header">
          <span className="bff-share icon" aria-hidden="true" />
          <h2 className="modal-title">{t('Share')}</h2>
        </div>
        <div className="modal-content-wrapper__body">
          <h3 className="body-title">
            { newShareLink ? t('Customize Share Link for') : t('Edit share link for') }
            <span className="bold-text">{`${assetQtyObject.qty} ${assetCopy}`}</span>
            <span>{restrictedCopy}</span>
          </h3>
          {this.renderRestrictedContent("link_access_options")}
          <div className="modal-row share-link-row">
            <h4 className="row-title">{shareCopy}</h4>
            <div className="share-link-container">
              <input
                id="share-url"
                className="inputs"
                type="text"
                value={link || ""}
                readOnly
              />
              <ClipboardCopy textToCopy={link}>
                <button className="button primary sm" type="button">{t('Copy')}</button>
              </ClipboardCopy>
            </div>
            <a
              className="share-link action-container"
              href={link}
              target="_blank"
              rel="noopener noreferrer"
            >
              <span className="bff-new-tab icon" />
              <h5 className="action-text">{t('Open in new tab')}</h5>
            </a>
            <a
              className="email-link action-container"
              href={`mailto:?&subject=link%20to%20${BF.fx.resource().name}&body=${link}`}
            >
              <span className="bff-email icon" />
              <h5 className="action-text">{t('Email link')}</h5>
            </a>
          </div>
          <div className="modal-row">
            <h4 className="row-title">{t('Name Your Share Link')}</h4>
            <input
              className="inputs"
              id="share-name"
              name="name"
              onChange={this.handleChange}
              value={name || ""}
              type="text"
            />
          </div>
          <div className="modal-row share-restrictions-container">
            {this.renderRestrictedContent("require_identification_checkbox")}
            <Checkbox
              checked={expires}
              labelHtml={labelCopy}
              size="sm"
              toggle={() => this.toggleLinkExpiration()}
            />
            <DateTimePicker
              displayCriterium={this.state.expires}
              selectedDate={availability_end_date}
              selectedTime={availability_end_time}
              selectedZone={availability_end_zone}
              updateDateTime={this.updateDateTimeEnd}
            />
          </div>
          <div className="feedback">
            { showFeedback ? t("Updated!") : "" }
          </div>
        </div>
        <div className="button-container share-modal-button-container">
          <button
            className="share-modal-delete-button"
            onClick={this.deleteShareLink}
            type="button"
          >
            <span className="bff-trash" />
            Delete
          </button>
          <div>
            <button
              className="button tertiary sm t-close-modal"
              onClick={this.props.closeModal}
              type="button"
            >
              {t('Close')}
            </button>
            <button
              className="button primary sm t-save"
              onClick={this.updateShareLink}
              type="button"
            >
              {newShareLink ? t('Save') : t('Update')}
            </button>
          </div>
        </div>
      </div>
    );
  }
}

BulkShareModal.propTypes = {
  closeModal: PropTypes.func.isRequired,
  selectedAssetKeys: PropTypes.instanceOf(Set).isRequired,
  digest: PropTypes.string
};

BulkShareModal.defaultProps = {
  digest: queryString.parse(window.location.search).digest
};

const ModalComponent = renderModal(BulkShareModal, 'BulkShareModal');
export default ModalComponent;
